import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GeneralService } from '@services/general.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-modal-cambia-estado',
  templateUrl: './modal-cambia-estado.component.html',
  styleUrls: ['./modal-cambia-estado.component.scss']
})
export class ModalCambiaEstadoComponent {
  @Input() cssClass: string;
  @Input() idPedido: number;
  @Input() estadoOld: number;
  @Input() estadoOldText: string;
  @Input() estadoNew: number;
  @Input() estados: Array<any>;
  changeStateForm: FormGroup;
  @Output() updateData = new EventEmitter();

  constructor(private modalService: NgbModal,
    private fb: FormBuilder,
    private toastr: ToastrService,
    public generalService: GeneralService) {
  }

  ngOnInit() {
    this.initializeForm();
  }
  ngOnChanges(changes: SimpleChanges): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    this.initializeForm();
  }

  initializeForm() {
    this.changeStateForm = this.fb.group({
      id_pedido: [this.idPedido, Validators.required],
      estado_old: [this.estadoOld, Validators.required],
      estado_old_text: [this.estadoOldText],
      estado_new: [this.estadoNew, Validators.required],
    });
  }

  open(content: any) {
    // Carga los estados si aún no los tenemos
    if (!this.estados || this.estados.length === 0) {
      this.generalService.getListar("estado")
        .then(res => {
          this.estados = res.data;
          this._openModal(content); // Abrimos el modal después de cargar los estados
        })
        .catch(err => console.error(err));
    } else {
      this._openModal(content); // Ya tenemos estados, abrimos directamente
    }
  }

  // Función privada para abrir el modal
  private _openModal(content: any) {
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      this.generalService.putEdita("pedido/cambia_estado", result.id_pedido, {
        "id_estado": result.estado_new
      })
        .then(() => this.generalService.postCrear("cambia_estado_log", {
          "id_pedido": result.id_pedido,
          "estado_old": result.estado_old,
          "estado_new": result.estado_new
        }))
        .then(() => {
          this.toastr.success('Cambio estado exitoso!');
          this.initializeForm();
          this.updateData.emit();
        })
        .catch(() => this.toastr.error('Error al crear!'))
    }, () => {
      // Cerrado sin acción
    });
  }
}
